<script>
  import SVGDraggable from './SVGDraggable.svelte'
  
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

	const log = console.log

  export let points = {
      a: {x:50 , y:50}
    , b: {x:50 , y:25}
    , c: {x:25 , y:25}
    , d: {x:25 , y:50}
  }

  function update(name, val) {
    points[name] = val
    dispatch('move', points)
  }

</script>

<g>
  <!-- CURVE: -->

  <path d="M {points.a.x} {points.a.y} C {points.b.x} {points.b.y} {points.c.x} {points.c.y} {points.d.x} {points.d.y}" 
    stroke="blue" stroke-width="0.5" fill="none"/>

  <!--  HANDLE LINES: -->

  <path d="M {points.a.x} {points.a.y} L {points.b.x} {points.b.y}" stroke="gray" stroke-dasharray="2 2" stroke-width="0.2" />
  <path d="M {points.c.x} {points.c.y} L {points.d.x} {points.d.y}" stroke="gray" stroke-dasharray="2 2" stroke-width="0.2" />

  <!-- HANDLES: -->

  <!-- A (start path) -->
  <SVGDraggable on:move={ev => update('a', ev.detail) }>
    <circle cx="{points.a.x}" cy="{points.a.y}" r="1" stroke="blue" fill="black" stroke-width="0.5" />
  </SVGDraggable>

  <!-- B (a related control point) -->
	<SVGDraggable on:move={ev => update('b', ev.detail) }>
	  <circle cx="{points.b.x}" cy="{points.b.y}" r="1" stroke="blue" fill="red"   stroke-width="0.5" />
  </SVGDraggable>

  <!-- C (d related control point) -->
	<SVGDraggable on:move={ev => update('c', ev.detail) }>
	  <circle cx="{points.c.x}" cy="{points.c.y}" r="1" stroke="blue" fill="red"   stroke-width="0.5" />
  </SVGDraggable>

  <!-- D (end path) -->
  <SVGDraggable on:move={ev => update('d', ev.detail) }>
    <circle cx="{points.d.x}" cy="{points.d.y}" r="1" stroke="blue" fill="black" stroke-width="0.5" />
  </SVGDraggable>
</g>

<style>

</style>